import _ from 'lodash';
import Device from '../Device';

const questions = [{
  model: 'flair',
  type: 'oauth',
  name: 'flair',
  label: 'step3OauthDeviceFlair',
  showNext: false,
  required: true,
  advanceOnEnter: true,
  advanceOnValue: true,
  update: values => ({
    additionalFields: {
      type: 'gravity',
      mfg: 'flair',
      tags: JSON.stringify(_.get(values, 'tags') || {}),
    },
  }),
}];

const addDevice = async (values, context, signup) => {
  const promise = new Promise((resolve, reject) => {
    signup.$root.$on('oauth.redirect', () => {
      resolve();
    });
  });
  signup.$root.$emit('oauth.submit', values, context);
  return promise;
};

const Flair = new Device('flair', { mfg: 'flair', questions, addDevice });

export default Flair;
